import { TOGGLE_SELECTOR } from "../types";

export const toggleSelector = () => ({
  type: TOGGLE_SELECTOR,
});
